import React, { useState, useEffect } from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo";
import { Link, withPrefix } from 'gatsby';
import Helmet from "react-helmet"
import RichText from '../components/richText';



const Condiciones = (props) => {

  const showCrediton =false;
  const assets = 'assets'


  //Metadata
  const $metadata = props.data.prismic.allMetadatas.edges[0].node;

  //Footer
  const $footer = { data: props.data.prismic.allFooters.edges[0].node, infoPopup: props.data.prismic.allInformacion_financieras.edges[0].node }
  const $layoutData = { $metadata, $footer };


  const $condiciones = props.data.prismic.allTerminos_y_condicioness.edges[0].node;


  return (

    <>

      <Layout data={$layoutData} footer={true} className={'u-facturacion'}>


        <SEO metadata={$metadata} title={'Términos y Condiciones'}></SEO>


        <>

          <Helmet>

          <link href={withPrefix(`../../${assets}/css/fixed/icons.css`)} rel="stylesheet" type="text/css" />
            <link href={withPrefix(`../../${assets}/css/fixed/fonts.css`)} rel="stylesheet" type="text/css" />
            <link href={withPrefix(`../../${assets}/css/fixed/screen.css?v=15`)} rel="stylesheet" type="text/css" />
            <link href={withPrefix(`../../${assets}/css/site/form.css?v=2`)} rel="stylesheet" type="text/css" />
            <link href={withPrefix(`../../${assets}/css/site/financial-info.css?v=4`)} rel="stylesheet" type="text/css" />


          </Helmet>


          <div className="o-wrapper o-section o-section--large">
            <h2 className={`c-title c-title--center c-title--blue ${showCrediton && 'c-title--red'}`}>Términos y Condiciones</h2>
            <div className="s-content o-wrapper o-wrapper--xs">

              <RichText render={$condiciones.contenido} />

            </div>
          </div>



        </>


      </Layout>


    </>
  );
}



export const query = graphql`
query CondicionesQuery {
  prismic {
    allMetadatas  {
      edges {
        node {
          ...MetadataFragment
        }
      }
    },
    allFooters {
      edges {
        node {
          ...FooterFragment
        }
      }
    },
    allTerminos_y_condicioness {
      edges {
        node {
          contenido
        }
      }
    },
    allInformacion_financieras {
      edges {
        node {
          ...InformacionFinancieraFragment
        }
      }
    }
   
  }
}
`


export default Condiciones;

